import React, { useContext, useEffect, useState } from "react";
import { AppointmentContext } from "../context/AppointmentContext";
import { useNavigate } from "react-router-dom";
import Calendar from "react-calendar";
import Modal from "react-modal";
import "react-calendar/dist/Calendar.css";

Modal.setAppElement("#root");

function PageSecond({ onNext, onPrevious, onReset }) {
  const navigate = useNavigate();
  const { setSelectionType, hospitalName } = useContext(AppointmentContext);

  const [modalOpen, setModalOpen] = useState(false);
  const [calendarDate, setCalendarDate] = useState(new Date());

  const handleSelection = (type) => {
    setSelectionType(type);
    onNext();
  };

  const currentYear = new Date().getFullYear();
  const minYear = currentYear - 10;
  const maxYear = currentYear + 1;

  const handleSelection1 = (type) => {
    navigate("/appointment-status");
  };
  const handleSelection2 = (type) => {
    navigate("/all-status");
  };
  const handleSelection3 = (type) => {
    navigate("/cancel-status");
  };

  const handleCalendarChange = (date) => {
    setCalendarDate(date);

    const formattedDate = date
      ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
      : "";

    sessionStorage.setItem("selectedDate", formattedDate);

    navigate("/appointment-status");
  };



  const handleYearChange = (e) => {
    const newYear = parseInt(e.target.value);
    const newDate = new Date(calendarDate);
    newDate.setFullYear(newYear);
    setCalendarDate(newDate);
  };

  const handleMonthChange = (e) => {
    const newMonth = parseInt(e.target.value);
    const newDate = new Date(calendarDate);
    newDate.setMonth(newMonth);
    setCalendarDate(newDate);
  };

  const tileDisabled = ({ date, view }) => {
    if (view !== "month") return false;

    const now = new Date();
    const minDate = new Date(currentYear - 10, 0);
    const maxDate = new Date(currentYear + 1, 11);

    return date < minDate || date > maxDate;
  };

  const years = Array.from(
    { length: maxYear - minYear + 1 },
    (_, i) => minYear + i
  );

  useEffect(() => {
    if (modalOpen) {
      setTimeout(() => {
        document.querySelectorAll("select").forEach((el) => el.blur());
      }, 100); // Delay ensures it's after modal render
    }
  }, [modalOpen]);


  return (
    <div className="card shadow-sm border-0">
      <div className="card-body">
        <h5 className="text-success fw-bold">
          {hospitalName === "hazra"
            ? " Chittaranjan National Cancer Institute, Hazra, Kolkata"
            : "Chittaranjan National Cancer Institute, New Town, Kolkata"}
        </h5>
        <p className="mb-4 fw-bold">
          <i class="fa fa-check-circle" aria-hidden="true"></i>&nbsp;
Select Mode of Appointment</p>

        <h6 className="fw-bold">Select consultation mode</h6>
        <div className="custom-option" role="button">
          <div
            onClick={() => handleSelection("Appointment")}
            className="list-group-item hospital-item mb-2 mt-2 d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer", backgroundColor:"lightcyan" }}
          >
            <div>
              <div className="fw-semibold">
                <span>Appointment</span>&nbsp;&nbsp;
                <i className="fas fa-person-walking fa-lg text-primary"></i>
              </div>
              <small className="text-muted">
                (For physical consultation with doctors)
              </small>
            </div>
            <i className="fa fa-chevron-right text-dark"></i>
          </div>
        </div>

        <h6 className="fw-bold mt-4">For existing appointment</h6>
        <div
          className="list-group mb-4"
          style={{ maxHeight: "200px", overflowY: "auto" }}
        >
            <div
            onClick={() => handleSelection2("View/Print appointment status")}
            className="list-group-item hospital-item mb-2 d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer",backgroundColor:"lightsteelblue"}}
          >
            <div>
              <span>All Appointments</span>&nbsp;&nbsp;
              <i className="fa fa-file text-primary"></i>
            </div>
            <i className="fa fa-chevron-right text-dark"></i>
          </div>
          
          <div
            onClick={() => handleSelection3("Cancel appointment")}
            className="list-group-item hospital-item mb-2 d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer",backgroundColor:"palevioletred" }}
          >
            <div>
              <span>Cancel Appointments</span>&nbsp;&nbsp;
              <i className="fa fa-trash text-primary"></i>
            </div>
            <i className="fa fa-chevron-right text-dark"></i>
          </div>
          <div
            onClick={() => handleSelection1("Appointment status")}
            className="list-group-item hospital-item mb-2 mt-2 d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer",backgroundColor:"lightgoldenrodyellow" }}
          >
            <div>
              <span>Pending Appointments</span>&nbsp;&nbsp;
             <i className="fa fa-clock text-primary" aria-hidden="true" ></i>
            </div>
            <i className="fa fa-chevron-right text-dark"></i>
          </div>
        


        </div>

        <div className="d-flex justify-content-between mt-4">
          <button
            onClick={onPrevious}
            className="inline-flex items-center gap-2 px-4 py-2 bg-blue-800 text-white text-sm font-semibold rounded-md shadow hover:bg-gray-700 transition duration-150"
          >
            <i className="fas fa-arrow-left"></i>
            Previous
          </button>

          {/* Start Again Button */}
          <button
            onClick={onReset}
            className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-md shadow hover:bg-blue-700 transition duration-150"
          >
            <i className="fas fa-rotate-right"></i>
            Start Again
          </button>
        </div>
      </div>

      {/* Modal for calendar selection */}

    </div>
  );
}

export default PageSecond;
